var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"save-image"},[_vm._t("default"),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.dataURL),expression:"dataURL"}],staticClass:"img",style:(_vm.imgStyle),attrs:{"src":_vm.dataURL}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }